import { render, staticRenderFns } from "./FundsView.vue?vue&type=template&id=09459cf0&scoped=true&"
import script from "./FundsView.vue?vue&type=script&lang=js&"
export * from "./FundsView.vue?vue&type=script&lang=js&"
import style0 from "./FundsView.vue?vue&type=style&index=0&id=09459cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09459cf0",
  null
  
)

export default component.exports